import { Record, List, Map } from 'immutable';
import User from './user';
import Activity from './activity';
import Photo from './photo';
import Like from './like';
import Comment from './comment';

const EntryRecord = Record({
  id: undefined,
  title: undefined,
  message: undefined,
  createdAt: undefined,
  user: User,
  activities: List.of(Activity),
  photos: List.of(Photo),
  likes: List.of(Like),
  comments: List.of(Comment),
  _links: new Map(),
  _forms: new Map()
});

class Entry extends EntryRecord {

  constructor(props) {
    props.user = new User(props.user);
    props.activities = props.activities.map(activityProps => new Activity(activityProps));
    props.photos = props.photos.map(photoProps => new Photo(photoProps));
    props.likes = props.likes.map(likeProps => new Like(likeProps));
    props.comments = props.comments.map(commentProps => new Comment(commentProps));

    super(props);
  }

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Entry;


// WEBPACK FOOTER //
// ./src/api/models/entry.js